import { Icon } from "@iconify/react";
import { Avatar, Flex, Text } from "@mantine/core";

import { formatDate } from "~/lib/date";

function NotificationItem(props: {
  id: number;
  title: string;
  date: string;
  icon: string;
  iconColor: string;
  iconBgColor: string;
}) {
  const AvatarIcon = ({
    icon,
    iconColor,
    iconBgColor,
  }: {
    icon: string;
    iconColor: string;
    iconBgColor: string;
  }) => {
    const isUrl = typeof icon === "string" && /^https?:\/\//.test(icon);

    return (
      <Avatar
        radius="xl"
        color={iconColor}
        bg={iconBgColor ? iconBgColor : ""}
        src={isUrl ? icon : undefined}
      >
        {isUrl ? null : (
          <Icon
            icon={icon}
            className={`${iconColor ? "h-[80%] w-[80%]" : "h-full w-full"}`}
          />
        )}
      </Avatar>
    );
  };

  return (
    <Flex gap={16} py={8} my={8} key={`notif-${props.id}`}>
      <Avatar radius="xl" color={props.iconColor}>
        <Icon icon={props.icon} className="h-5 w-5" />
      </Avatar>
      <Flex direction="column">
        <Text fw={600} className="text-[14px]">
          {props.title}
        </Text>
        <Text fw={500} size="xs" c="gray">
          {formatDate(props.date, "dddd, DD MMMM YYYY")}
        </Text>
      </Flex>
    </Flex>
  );
}

export default NotificationItem;
